// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__vxFaT","form":"styles_form__vxDYb","disclaimer":"styles_disclaimer__C1wY9"};